<template>
  <component :is="startPageComponent" />
</template>

<script>
import events from '@/utils/helpers/events';
import { hotjarEvent } from '@/utils/hotjar';

export default {
  name: 'StartPageRouter',

  components: {
    StartPage: () =>
      import(/* webpackChunkName: "start-page" */ './StartPage.vue'),
    NewStartPage: () =>
      import(/* webpackChunkName: "new-start-page" */ './NewStartPage.vue')
  },

  computed: {
    startPageComponent() {
      return this.$growthbook.isFeatureFlagEnabled('new-startpage')
        ? 'NewStartPage'
        : 'StartPage';
    }
  },

  created() {
    events.emitEvent(events.eventTypes.PAGEVIEW, 'Start Page', {
      referrer: document.referrer,
      search: document.location ? document.location.search : undefined,
      userAgent: navigator.userAgent
    });
  },

  mounted() {
    // Hotjar session capture is targeted on this event (Hotjar dashboard) —
    // fired here so both startpage variants are recorded, SE market only.
    if (this.$country.isCountry('se')) {
      hotjarEvent('startpage-recording');
    }
  }
};
</script>
